import { installSteps } from "@/mocks/home";

export default function InstallSteps() {
  return (
    <section id="guide" className="w-full bg-secondary-50 py-16 md:py-20">
      <div className="w-full px-4 md:px-8">
        <div className="max-w-2xl">
          <span className="text-xs font-label tracking-widest text-primary-700">GUIDE</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            四步完成安装，新手也能上手
          </h2>
          <p className="mt-3 text-sm md:text-base leading-7 text-foreground-600">
            从确认设备到打开阅读，整个过程只需要几分钟。按下面的顺序操作可以避开大多数安装问题。
          </p>
        </div>

        <ol className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {installSteps.map((step) => (
            <li
              key={step.step}
              className="relative rounded-lg border border-background-200 bg-background-50 p-5"
            >
              <div className="flex items-center justify-between">
                <span className="w-11 h-11 flex items-center justify-center rounded-lg bg-primary-100 text-primary-700 text-xl">
                  <i className={step.icon}></i>
                </span>
                <span className="font-heading text-2xl font-bold text-background-300">{step.step}</span>
              </div>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{step.title}</h3>
              <p className="mt-2 text-sm leading-6 text-foreground-600">{step.desc}</p>
            </li>
          ))}
        </ol>

        <div className="mt-8 flex flex-col sm:flex-row sm:items-center gap-4 rounded-lg border border-primary-200 bg-primary-50 px-5 py-4">
          <span className="w-10 h-10 flex items-center justify-center rounded-md bg-primary-600 text-background-50 shrink-0">
            <i className="ri-lightbulb-line text-lg"></i>
          </span>
          <p className="text-sm leading-6 text-foreground-700">
            小提示：安装完成后建议先登录账号再浏览，这样书架与阅读进度才能在手机、平板之间同步。
          </p>
        </div>
      </div>
    </section>
  );
}